import { UIText2 } from '@cian/ui-kit';

import * as React from 'react';
import cn from 'classnames';

import { FieldProps } from './types';

import * as styles from './Field.css';

export const Field: React.FC<FieldProps> = props => {
  const { children, isMobile, errorMessage, onBlur } = props;

  const errorColor = React.useMemo(() => (isMobile ? 'error_100' : 'white_100'), [isMobile]);
  const hasError = errorMessage != null;

  return (
    <div className={cn(styles['field'], isMobile && styles['mobile'])} onBlur={onBlur}>
      <div className={cn(styles['children-container'], hasError && 'cui-invalid')}>
        {React.cloneElement(children, { invalid: hasError })}
        {!!errorMessage?.length && (
          <div className={cn(styles['error-message-container'])}>
            <div className={cn(styles['error-message'])}>
              <UIText2 color={errorColor} fontWeight="normal" whiteSpace={isMobile ? 'pre-wrap' : 'nowrap'} as="div">
                {errorMessage}
              </UIText2>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
